import { useNavigate } from 'react-router-dom';

// ── OPERARIO: INICIO ─────────────────────────────────────────────
export const InicioSection = ({ setAlmTab, historial, modulos }) => {
  const navigate = useNavigate();
  return (
  <div className="space-y-4">

    <p className="text-xs text-gray-500 uppercase font-semibold tracking-wide">Acceso rápido</p>
    <div className="space-y-3">
      {modulos?.reservas === true && (
      <div onClick={() => { navigate("/app/home/almacen"); setAlmTab("Reservas"); }} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-blue-50 border border-gray-100">
        <div className="w-11 h-11 rounded-xl bg-blue-100 flex items-center justify-center text-blue-700 text-xl">📅</div>
        <div className="flex-1">
          <p className="font-semibold text-gray-800 text-sm">Reserva de equipos</p>
          <p className="text-xs text-gray-500">Reserva de transpaletas</p>
        </div>
        <span className="text-gray-400 text-sm">›</span>
      </div>
      )}
      {modulos?.almacen === true && (
      <div onClick={() => { navigate("/app/home/almacen"); setAlmTab("Transpaleta Eléctrica"); }} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-green-50 border border-gray-100">
        <div className="w-11 h-11 rounded-xl bg-green-100 flex items-center justify-center text-green-700 text-xl">🏭</div>
        <div className="flex-1">
          <p className="font-semibold text-gray-800 text-sm">Almacén / Flota</p>
          <p className="text-xs text-gray-500">APPCC · Flota · SDC · Carretillas</p>
        </div>
        <span className="text-gray-400 text-sm">›</span>
      </div>
      )}
      {modulos?.almacen === true && (
      <div onClick={() => { navigate("/app/home/almacen"); setAlmTab("Roturas"); }} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-red-50 border border-gray-100">
        <div className="w-11 h-11 rounded-xl bg-red-100 flex items-center justify-center text-red-700 text-xl">🔧</div>
        <div className="flex-1">
          <p className="font-semibold text-gray-800 text-sm">Reportar avería/rotura supervisor</p>
          <p className="text-xs text-gray-500">Notificar al supervisor</p>
        </div>
        <span className="text-gray-400 text-sm">›</span>
      </div>
      )}
      {modulos?.documentos === true && (
        <div onClick={() => navigate("/app/home/documentos")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-orange-50 border border-gray-100">
        <div className="w-11 h-11 rounded-xl bg-orange-100 flex items-center justify-center text-orange-700 text-xl">📎</div>
        <div className="flex-1">
        <p className="font-semibold text-gray-800 text-sm">Subir documento Almacén</p>
         <p className="text-xs text-gray-500">Foto o archivo para el responsable</p>
        </div>
       <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
      {modulos?.historial === true && (
      <div onClick={() => navigate("/app/home/historial")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-purple-50 border border-gray-100">
        <div className="w-11 h-11 rounded-xl bg-purple-100 flex items-center justify-center text-purple-700 text-xl">📋</div>
        <div className="flex-1">
          <p className="font-semibold text-gray-800 text-sm">Historial</p>
          <p className="text-xs text-gray-500">Pendientes de validación</p>
        </div>
        {historial.length > 0 && <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-1 rounded-full">{historial.length}</span>}
      </div>
      )}
      {modulos?.entradas === true && (
        <div onClick={() => navigate("/app/home/entradas")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-cyan-50 border border-gray-100">
          <div className="w-11 h-11 rounded-xl bg-cyan-100 flex items-center justify-center text-cyan-700 text-xl">🚛</div>
          <div className="flex-1">
            <p className="font-semibold text-gray-800 text-sm">Entradas camiones</p>
            <p className="text-xs text-gray-500">Registro de entrada de mercancía</p>
          </div>
          <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
      {modulos?.salidas === true && (
        <div onClick={() => navigate("/app/home/salidas")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-teal-50 border border-gray-100">
          <div className="w-11 h-11 rounded-xl bg-teal-100 flex items-center justify-center text-teal-700 text-xl">📦</div>
          <div className="flex-1">
            <p className="font-semibold text-gray-800 text-sm">Salidas contenedores</p>
            <p className="text-xs text-gray-500">Checklist de salida de contenedor</p>
          </div>
          <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
      {modulos?.fotos_contenedor === true && (
        <div onClick={() => navigate("/app/home/fotos-contenedor")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-pink-50 border border-gray-100">
          <div className="w-11 h-11 rounded-xl bg-pink-100 flex items-center justify-center text-pink-700 text-xl">📸</div>
          <div className="flex-1">
            <p className="font-semibold text-gray-800 text-sm">Fotos contenedor</p>
            <p className="text-xs text-gray-500">Subir fotos por número de carga</p>
          </div>
          <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
      {modulos?.facturacion === true && (
        <div onClick={() => navigate("/app/home/facturacion")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-indigo-50 border border-gray-100">
          <div className="w-11 h-11 rounded-xl bg-indigo-100 flex items-center justify-center text-indigo-700 text-xl">🧾</div>
          <div className="flex-1">
            <p className="font-semibold text-gray-800 text-sm">Facturación</p>
            <p className="text-xs text-gray-500">Facturación de trabajos</p>
          </div>
          <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
      {modulos?.inventario === true && (
        <div onClick={() => navigate("/app/home/inventario-stock")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-lime-50 border border-gray-100">
          <div className="w-11 h-11 rounded-xl bg-lime-100 flex items-center justify-center text-lime-700 text-xl">📋</div>
          <div className="flex-1">
            <p className="font-semibold text-gray-800 text-sm">Inventario</p>
            <p className="text-xs text-gray-500">Stock, ajustes y recuento</p>
          </div>
          <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
      {modulos?.pedidos === true && (
        <div onClick={() => navigate("/app/home/pedidos")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-fuchsia-50 border border-gray-100">
          <div className="w-11 h-11 rounded-xl bg-fuchsia-100 flex items-center justify-center text-fuchsia-700 text-xl">🧾</div>
          <div className="flex-1">
            <p className="font-semibold text-gray-800 text-sm">Preparación de pedidos</p>
            <p className="text-xs text-gray-500">Nuevo pedido y seguimiento</p>
          </div>
          <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
      {modulos?.archivo === true && (
        <div onClick={() => navigate("/app/home/archivo-internacional")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-slate-50 border border-gray-100">
          <div className="w-11 h-11 rounded-xl bg-slate-100 flex items-center justify-center text-slate-700 text-xl">🗂️</div>
          <div className="flex-1">
            <p className="font-semibold text-gray-800 text-sm">Archivo</p>
            <p className="text-xs text-gray-500">Consulta de albaranes, salidas y fotos</p>
          </div>
          <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
      {modulos?.kpis === true && (
        <div onClick={() => navigate("/app/home/kpis-internacional")} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-violet-50 border border-gray-100">
          <div className="w-11 h-11 rounded-xl bg-violet-100 flex items-center justify-center text-violet-700 text-xl">📊</div>
          <div className="flex-1">
            <p className="font-semibold text-gray-800 text-sm">KPIs</p>
            <p className="text-xs text-gray-500">Panel de indicadores del almacén</p>
          </div>
          <span className="text-gray-400 text-sm">›</span>
        </div>
      )}
    </div>
  </div>
  );
};
